export const getCompanyLabels = (companyName) => {
  const name = (companyName || '').toLowerCase();
  if (name.includes('hospital')) {
    return {
      visitor: 'Patient/Visitor',
      visitorPlural: 'Patients/Visitors',
      employee: 'Doctor/Staff',
      employeePlural: 'Doctors/Staff',
      host: 'Doctor/Consultant to Meet'
    };
  }
  if (name.includes('real estate') || name.includes('realty')) {
    return {
      visitor: 'Client',
      visitorPlural: 'Clients',
      employee: 'Agent',
      employeePlural: 'Agents',
      host: 'Agent'
    };
  }
  // Default (Elsner Technologies Pvt Lmt or other)
  return {
    visitor: 'Visitor',
    visitorPlural: 'Visitors',
    employee: 'Employee',
    employeePlural: 'Employees',
    host: 'Person to Meet'
  };
};

export const getTranslatedLabel = (originalLabel, companyName) => {
  const labels = getCompanyLabels(companyName);
  const label = (originalLabel || '').trim();
  const labelLower = label.toLowerCase();
  if (labelLower === 'first name') return 'First Name';
  if (labelLower === 'last name') return 'Last Name';
  if (labelLower === 'email') return 'Email';
  if (labelLower === 'mobile number') return 'Mobile Number';
  if (labelLower === 'visitor photo') return 'Photo';
  if (labelLower === 'person to meet') return labels.host;
  if (labelLower === 'purpose') return 'Purpose of Visit';
  return originalLabel;
};

export const getEmployeeTranslatedLabel = (originalLabel, companyName) => {
  const labels = getCompanyLabels(companyName);
  const label = (originalLabel || '').trim();
  const labelLower = label.toLowerCase();
  if (labelLower === 'first name') return 'First Name';
  if (labelLower === 'last name') return 'Last Name';
  if (labelLower === 'email' || labelLower === 'work email') return 'Email';
  if (labelLower === 'mobile number' || labelLower === 'phone number') return 'Phone Number';
  if (labelLower === 'employee id' || labelLower === 'employeeid') return 'Employee ID';
  return originalLabel;
};

export const isEmployeeRole = (role) => {
  const r = (role || '').toLowerCase();
  return r !== 'admin' && r !== 'receptionist' && r !== 'superadmin';
};
